// NoticeSection.js
import React from "react";
import "./NoticeSection.css";

const notices = [
    {
        title: "Annual General Body Meeting of the Haryana Library Association-(12-08-2025)",
        pdfUrl: "/notices/2025-08-12-agnda_hla.pdf",
    },
    {
        title: "One Day National Workshop organised by DAV College Pundri and HLA (12-08-2025)",
        pdfUrl: "/notices/2025-08-12-workshop-by-dav-college-pundri.pdf",
    },
    {
        title: "Association Membership Form",
        pdfUrl: "/association-membership-form.pdf",
    },
    {
        title: "Annual Membership Renewal for the Year 2025-26",
        pdfUrl: "/notices/2025-06-10_Annual_Membership_Renewal_for_the_Year_2025-26.pdf",
    },

    {
        title: "HLA-QR-Code for Payment",
        pdfUrl: "/hla-qr-code-for-payment.jpg",
    },
];

const NoticeSection = () => {
    return (
        <div name="notices">
            {/* <section className="md:px-20 w-full bg-[#ffe6e6] body-font sm:p-2 md:pl-10 lg:pl-24"> */}
            <section className="w-full bg-[#ffe6e6] body-font pt-2 md:pt-10 lg:pt-24 pr-2 md:pr-10 lg:pr-24 pb-2 md:pb-10 lg:pb-24 pl-2 md:pl-10 lg:pl-24">
            {/* <section className="w-full bg-[#ffe6e6] body-font  p-[5rem]"> */}
                {/* <div className="notice-container pt-3.75 pr-1.25 pb-3.75 pl-2"   > */}  
                <div className="notice-container pt-4 pr-1.25 pb-3.75 md:pl-24"   >  
                {/* <div className="notice-container "> */}
                    <h1 className="notice-heading">📢 Notice Board</h1>
                    <div className="notice-vertical-scroll">
                        <div className="notice-track">
                            {notices.map((notice, index) => (
                                <div
                                    key={index}
                                    className="notice-item"
                                    onClick={() => window.open(notice.pdfUrl, "_blank")}
                                >
                                    <strong>{index + 1}.</strong> 📌 {notice.title}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NoticeSection;
